import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { injectReducer } from "../redux/store";
import roleBasedReducers from "../utils/roleBasedReducers";

import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";

const PageLoader = lazy(() => import("../components/Spinner/PageLoader"));
const Layout = lazy(() => import("../components/Layouts/Layout"));

const Login = lazy(() => import("../pages/common/auth/Login"));
const NotFoundPage = lazy(() => import("../pages/common/NotFoundPage"));

const Settings = lazy(() => import("../pages/Admin/Setting/Settings"));


const AppRouter = () => {
    let { user } = useSelector((state) => state.auth);
   

    const isAuthenticated = !!user;

    if (isAuthenticated) {
        const reducersToInject = roleBasedReducers[user.role];
        if (reducersToInject) {
            Object.entries(reducersToInject).forEach(([key, reducer]) => {
                injectReducer(key, reducer);
            });
        }
    }
    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                {/* Public routes */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                </Route>

                {/* Protected routes */}
                <Route element={<ProtectedRoute requiredRoles={['admin']} />}>
                    <Route path="/admin/" element={<Layout title="Dashboard"><Settings /></Layout>} />
                    <Route path="/admin/dashboard" element={<Layout title="Settings"><Settings /></Layout>} />
                    <Route path="/admin/*" element={<Layout><NotFoundPage /></Layout>} />
                </Route>
            </Routes>
        </Suspense>
    )
}

export default AppRouter;